import React, {useEffect, useRef} from "react";
import {Box} from "@mui/material";
import {v4 as uuidv4} from "uuid";
import mermaid from "mermaid/dist/mermaid.esm.mjs";

mermaid.initialize({
  startOnLoad: false
});

const MermaidGraphViewer = ({graphDefinition}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && graphDefinition) {
      const id = `mermaid-${uuidv4()}`;
      mermaid
        .render(id, graphDefinition)
        .then(({svg}) => {
          ref.current.innerHTML = svg;
        })
        .catch(error => {
          console.error("Mermaid graph rendering error:", error);
        });
    }
  }, [graphDefinition]);

  return (
    <Box
      ref={ref}
      className="mermaid-container"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center"
      }}
    />
  );
};

export default MermaidGraphViewer;
